import React from "react";

/* ─────────────────────────────────────────────────
   Skeleton Loader — used for Dashboard & User pages
   Shows shimmer cards that match the real layout
───────────────────────────────────────────────── */
const SkeletonLoader = () => (
  <>
    <style>{`
      @keyframes sk-shimmer {
        0%   { background-position: -600px 0; }
        100% { background-position:  600px 0; }
      }
      .sk-wrap {
        display: flex; flex-direction: column;
        gap: 22px; padding: 26px 28px;
        max-width: 1400px; margin: 0 auto;
        background: #F2F2F2; min-height: 100vh;
      }

      /* shimmer base */
      .sk-bone {
        background: linear-gradient(
          90deg,
          #e0e0e0 25%,
          #f0f0f0 50%,
          #e0e0e0 75%
        );
        background-size: 600px 100%;
        animation: sk-shimmer 1.4s infinite linear;
        border-radius: 10px;
      }

      /* welcome banner */
      .sk-banner { height: 148px; border-radius: 18px; }

      /* cards row */
      .sk-cards { display: grid; grid-template-columns: repeat(4,1fr); gap: 18px; }
      .sk-card   { height: 140px; border-radius: 16px; }

      /* bottom row */
      .sk-bottom { display: grid; grid-template-columns: 1fr 300px; gap: 22px; }
      .sk-chart  { height: 348px; border-radius: 16px; }
      .sk-side   { height: 348px; border-radius: 16px; }

      /* table page skeleton */
      .sk-toolbar { height: 64px; border-radius: 14px; margin-bottom: 20px; }
      .sk-table-card { background:#fff; border-radius:18px; padding:24px; border:1.5px solid #CBCBCB; }
      .sk-thead { height: 44px; border-radius: 10px; margin-bottom: 10px; }
      .sk-row   { height: 54px; border-radius: 8px; margin-bottom: 8px; }

      @media(max-width:1000px){ .sk-bottom{ grid-template-columns:1fr; } .sk-side{ display:none; } }
      @media(max-width:1100px){ .sk-cards{ grid-template-columns:repeat(2,1fr); } }
      @media(max-width:560px) { .sk-cards{ grid-template-columns:1fr; } }
    `}</style>

    <div className="sk-wrap">
      {/* banner */}
      <div className="sk-bone sk-banner" />

      {/* 4 stat cards */}
      <div className="sk-cards">
        {[1,2,3,4].map(i => <div key={i} className="sk-bone sk-card" />)}
      </div>

      {/* chart + side */}
      <div className="sk-bottom">
        <div className="sk-bone sk-chart" />
        <div className="sk-bone sk-side" />
      </div>
    </div>
  </>
);

/* Exported table-page skeleton used in Adduser */
export const TableSkeleton = () => (
  <>
    <style>{`
      @keyframes sk-shimmer2 {
        0%   { background-position: -600px 0; }
        100% { background-position:  600px 0; }
      }
      .sk2-bone {
        background: linear-gradient(90deg,#e0e0e0 25%,#f0f0f0 50%,#e0e0e0 75%);
        background-size:600px 100%;
        animation:sk-shimmer2 1.4s infinite linear;
        border-radius:10px;
      }
      .sk2-wrap { display:flex; flex-direction:column; gap:0; max-width:1400px; margin:0 auto; }
      .sk2-top  { height:72px; border-radius:18px; margin-bottom:20px; }
      .sk2-card { background:#fff; border-radius:18px; padding:24px; border:1.5px solid #CBCBCB; box-shadow:0 3px 14px rgba(0,0,0,.06); }
      .sk2-th   { height:42px; border-radius:10px; margin-bottom:12px; }
      .sk2-row  { height:52px; border-radius:8px; margin-bottom:8px; }
      .sk2-pg   { height:36px; width:200px; border-radius:10px; margin:16px auto 0; }
    `}</style>
    <div className="sk2-wrap">
      <div className="sk2-bone sk2-top" />
      <div className="sk2-card">
        <div className="sk2-bone sk2-th" />
        {[1,2,3,4,5,6,7].map(i => <div key={i} className="sk2-bone sk2-row" />)}
        <div className="sk2-bone sk2-pg" />
      </div>
    </div>
  </>
);

export default SkeletonLoader;
